import {IconSVG} from "../../../ui/icon/IconSVG";
import {classByArray} from "../../../utils/htmlUtils";


interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children?: React.ReactNode
    variant?: "default" | "primary" | "outline-primary" | "secondary" | "outline-secondary" | "success" | "outline-success" | "danger" | "outline-danger" | "warning" | "outline-warning" | "info" | "outline-info" | "light" | "outline-light" | "dark" | "outline-dark" | "link"
    className?: string
    icon?: string
    iconSize?: string
    iconRight?: string
    tintColor?: string
}

function BtnDefault({
                        children,
                        variant = 'default',
                        className = '',
                        icon,
                        iconRight,
                        tintColor,
                        iconSize = "16px",
                        ...rest
                    }: ButtonProps) {
    const classList = classByArray(['sh btn', `btn-${variant}`, className])
    return (
        <button type="button" className={classList} {...rest}>
            {icon && <IconSVG icon={icon} size={iconSize} className={`${children ? 'me-2' : ''}`}
                              tintColor={tintColor}/>}
            {children}
            {iconRight && (
                <IconSVG icon={iconRight} size={iconSize} className={`${children ? 'ms-2' : ''}`}
                         tintColor={tintColor}/>
            )}
        </button>
    )
}

export default BtnDefault
